import * as angular from "angular";
import jsonSchemaForm from "../json-schema-form";
import template from "./schema-array-item-modal.html";
import "./schema-array-item-modal.less";

export function controller($scope) {
	const ctrl = this;

	ctrl.$onInit = () => {
		const resolve = ctrl.resolve ?? {};
		ctrl.schema = resolve.schema;
		ctrl.model = angular.copy(resolve.model ?? {});
		ctrl.title = `${resolve.isNew ? "Add" : "Edit"} ${resolve.title || "Entry"}`;
	};

	ctrl.cancel = () => {
		ctrl.modalInstance.dismiss();
	};

	ctrl.save = () => {
		if(!ctrl.itemForm) {
			return false;
		}

		$scope.$broadcast("schemaFormValidate", ctrl.itemForm.$name);
		if(ctrl.itemForm?.$invalid) {
			return false;
		}

		ctrl.modalInstance.close(angular.copy(ctrl.model));
		return true;
	};
}

export default angular
	.module("vesl.extensions.json-schema.schema-array-item-modal", [jsonSchemaForm])
	.component("schemaArrayItemModal", {
		controller,
		template,
		bindings: {
			close: "&",
			dismiss: "&",
			modalInstance: "<",
			resolve: "<"
		}
	})
	.name;
